import React from 'react';

import Badge, {BadgeColor} from 'ui-library/Badge';

function BetaBadge(): JSX.Element {
  return (
    <Badge color={BadgeColor.PURPLE} bold={true}>
      Preview
    </Badge>
  );
}

export default BetaBadge;
